import * as cnpj from '@fnando/cnpj';
import * as cpf from '@fnando/cpf';
import { z } from 'zod';
import { CustomerBilling, CustomerType } from '../../enums/Customer';
import { AddressSchema } from '../../types/Address';
import { BaseSchema } from '../BaseSchema';
import { AWSCredentialSchema } from './AWSCredential';
export var CustomerSchema = BaseSchema.extend({
    iuguId: z.string().optional(),
    stripeId: z.string().optional(),
    type: z.nativeEnum(CustomerType),
    displayName: z.string().min(1),
    email: z.string().optional().refine(function (v) { return v ? z.string().email().safeParse(v).success : true; }),
    legalName: z.string().min(1),
    federalDocument: z.string().min(1),
    partner_: z.union([z.string(), z.any()]).optional(),
    address: AddressSchema.deepPartial().optional(),
    // TODO: @theinvensi - remove this field
    billing: z.nativeEnum(CustomerBilling),
    active: z.boolean(),
    // TODO: @theinvensi - remove this field
    partner: z.union([z.string(), z.any()]).optional(),
    // TODO: @theinvensi - remove this field
    asPartner: z.boolean(),
    awsCredentials: AWSCredentialSchema,
    logoFile: z.any().optional(),
    devices: z.any().array().optional(),
    usersWithAuthorization: z.custom().optional(),
    // TODO: @theinvensi - remove this field
    nOfEmployees: z.string().optional()
})
    .refine(function (_a) {
    var type = _a.type, federalDocument = _a.federalDocument;
    switch (type) {
        case CustomerType["BUSINESS"]: {
            return cnpj.isValid(federalDocument);
        }
        case CustomerType["PERSON"]: {
            return cpf.isValid(federalDocument);
        }
    }
}, "invalid \"federalDocument\" due the \"type\"");
